import { useEffect } from 'react'
import { Button, Loading } from 'components'
import { useAccountActions } from 'hooks/userHooks'
import { noop } from 'utils'
import { UserType } from 'types'
export type DeactivateTMATTBtnProps = {
  userId: string
  userType?: UserType
  disabled?: boolean
  onDone?: (message: string) => void
  onError?: (message: string) => void
}
export const DeactivateTMATTBtn = ({
  disabled = false,
  userType,
  userId,
  onDone = noop,
  onError = noop,
}: DeactivateTMATTBtnProps) => {
  const [state, { deactivateTMATT }] = useAccountActions()
  useEffect(() => {
    if (state.matches('success')) {
      onDone('User LMS account successfully deactivated!')
    } else if (state.matches('failed')) {
      onError('Failed to deactivate LMS account, please try again')
    }
  }, [state, onDone, onError])
  return (
    <Button
      type="button"
      variant="buttons.outline"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 50,
      }}
      disabled={disabled || state.matches('syncing')}
      onClick={() => deactivateTMATT({ userId, userType })}>
      {state.matches('syncing') ? (
        <Loading />
      ) : (
        <span>Deactivate LMS Course</span>
      )}
    </Button>
  )
}
